<div class="flex-row">
    <div class="flex-row flex" #infiniteScrollContainerBuildActivities style="overflow-x: auto">
        @if (isView()) {
            <div
                class="cb-padding-left-3x cb-padding-right-3x cb-padding-bottom-3x flex-col flex-100"
            >
                <div class="start-center flex-row layoutGap-16">
                    <h3 class="mat-headline-6 flex">Build Activities</h3>
                    <button mat-raised-button (click)="generateReport()" color="primary">
                        Generate Report
                    </button>
                    <button mat-raised-button (click)="newActivityClicked()" color="primary">
                        New Activity
                    </button>
                </div>
                <form>
                    <div class="flex-row flex">
                        <div
                            class="cb-margin-top cb-margin-bottom cb-margin-right flex-row flex-50"
                        >
                            <mat-icon class="cb-margin-top-2x cb-margin-right"> search </mat-icon>
                            <mat-form-field class="flex">
                                <mat-label>Activity Code</mat-label>
                                <input
                                    matInput
                                    [(ngModel)]="userCacheItem.data.activityCode"
                                    name="searchActivityCode"
                                />
                            </mat-form-field>
                        </div>
                        <div
                            class="cb-margin-top cb-margin-bottom cb-margin-right flex-row flex-50"
                        >
                            <mat-icon class="cb-margin-top-2x cb-margin-right"> search </mat-icon>
                            <mat-form-field class="flex">
                                <mat-label>Activity Name</mat-label>
                                <input
                                    matInput
                                    [(ngModel)]="userCacheItem.data.activityName"
                                    name="searchActivityName"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </form>
                <cb-table
                    label="Build Activities"
                    #infiniteScrollTable
                    maxHeightOffset="251"
                    [stringColumns]="[
                        'Code',
                        'Activity',
                        'Version',
                        'Active',
                        'Compliance',
                        'Show Draft Activity To Supplier',
                        'Retained %',
                        ''
                    ]"
                    [loaded]="!searchIsLoading"
                    infiniteScroll
                    [immediateCheck]="false"
                    [infiniteScrollContainer]="infiniteScrollTable?.infiniteScrollContainer"
                    (scrolled)="doSearch()"
                >
                    <tbody cbTableBody>
                        @for (element of searchResults; track element) {
                            <tr>
                                <cb-td-text [value]="element.code"></cb-td-text>
                                <cb-td-text [value]="element.name"></cb-td-text>
                                <cb-td-text [value]="element.version"></cb-td-text>
                                <cb-td-checkbox [value]="element.isActive"></cb-td-checkbox>
                                <cb-td-checkbox [value]="element.hasCompliance"></cb-td-checkbox>
                                <cb-td-checkbox
                                    [value]="element.showDraftActivityToSupplier"
                                ></cb-td-checkbox>
                                <cb-td-text [value]="element.retain + '%'"></cb-td-text>
                                <td cbTableShrinkCol cbTableStickyCol="end">
                                    <button mat-icon-button (click)="editClicked(element)">
                                        <mat-icon> edit </mat-icon>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </cb-table>
            </div>
        }
        @if (isEdit()) {
            <div class="cb-margin-left-3x cb-margin-right-3x cb-margin-bottom-3x flex-col flex">
                <div class="start-center flex-row">
                    <h3 class="mat-headline-6">Build Activities</h3>
                </div>
                <div class="flex-row flex">
                    <form class="flex-100" #buildActivityForm="ngForm">
                        <mat-tab-group class="flex" mat-stretch-tabs="false">
                            <mat-tab label="Activity Details">
                                @if (mappedItem && buildActivityForm) {
                                    <build-activity-details
                                        [buildActivity]="mappedItem"
                                        [buildActivityForm]="buildActivityForm"
                                    >
                                    </build-activity-details>
                                }
                            </mat-tab>
                            <mat-tab label="Activity Schedule">
                                @if (mappedItem && buildActivityForm) {
                                    <build-activity-schedule
                                        [buildActivity]="mappedItem"
                                        [buildActivityForm]="buildActivityForm"
                                    >
                                    </build-activity-schedule>
                                }
                            </mat-tab>
                            <mat-tab label="Trade/Supply Types">
                                @if (mappedItem && buildActivityForm) {
                                    <build-activity-trade-and-supply-types
                                        [buildActivity]="mappedItem"
                                        [buildActivityForm]="buildActivityForm"
                                    >
                                    </build-activity-trade-and-supply-types>
                                }
                            </mat-tab>
                        </mat-tab-group>
                    </form>
                </div>
            </div>
        }
    </div>
    @if (isEdit() && mappedItem) {
        <cb-side-bar class="flex-10">
            <div class="flex-col flex">
                <h3 class="mat-headline-6">
                    {{ sideBarBuildActivityCode }}
                </h3>
                <h3>
                    {{ sideBarBuildActivityName }}
                </h3>
                <button
                    class="cb-margin"
                    mat-raised-button
                    color="primary"
                    (click)="generateReport()"
                >
                    Report
                </button>
                <button
                    mat-raised-button
                    class="cb-margin"
                    color="primary"
                    (click)="save()"
                    [disabled]="!formDirty() || !formValid()"
                >
                    Save
                </button>
                <button
                    mat-raised-button
                    class="cb-margin"
                    color="primary"
                    (click)="goBack()"
                    [disabled]="formDirty()"
                >
                    Back
                </button>
                <button
                    mat-raised-button
                    class="cb-margin"
                    color="primary"
                    (click)="goBack()"
                    [disabled]="!formDirty()"
                >
                    Cancel
                </button>
            </div>
        </cb-side-bar>
    }
</div>
